<template>
  <div :class="[componentClass.root, classes]">
    <dt>{{ label }}</dt>

    <dd>
      <slot />
    </dd>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useComponentClass } from '@thomasaull-shared/composables'

export interface Props {
  label: string
  variant?: 'default' | 'error'
}

const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits<{
  (event: 'example', id: string): void
}>()

const componentClass = useComponentClass({ props })

const classes = computed(() => {
  return [componentClass.propModifier({ name: 'variant' })]
})
</script>

<style lang="scss">
.PmMetaListItemPure {
  $block: &;

  display: contents;

  &--variantError {
    color: color.$danger-700;
  }

  /* stylelint-disable-next-line plugin/selector-bem-pattern */
  & dt {
    /* stylelint-disable-next-line plugin/selector-bem-pattern */
    &::after {
      content: ':\00a0';
    }
  }
  /* stylelint-disable-next-line plugin/selector-bem-pattern */
  & dd {
    display: inline;
  }
}
</style>
